/**
 * Invariant violations are bugs, not business errors: they throw.
 * Business errors go through `Result<T, E>` instead.
 */
export class InvariantError extends Error {
  override readonly name = "InvariantError";
}

export function invariant(condition: boolean, message: string): asserts condition {
  if (!condition) throw new InvariantError(message);
}

export function assertSafeInt(value: number, label = "value"): void {
  if (!Number.isSafeInteger(value)) {
    throw new InvariantError(`${label} must be a safe integer, got ${value}`);
  }
}

export function assertNever(value: never, label = "value"): never {
  throw new InvariantError(`unexpected ${label}: ${JSON.stringify(value)}`);
}
